import React, { memo } from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TextEditWarningModal = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="TextEditWarningModal" className="dialog-text">
      <p>{t('clientTags.editTagModal.text1')}</p>
      <p>{t('clientTags.editTagModal.text2')}</p>
      <p>{t('clientTags.editTagModal.text3')}</p>
    </div>
  );
};

export default memo(TextEditWarningModal);
